import { Box, Grid, LinearProgress, Typography } from '@mui/material';
import { useResourceTypes } from 'hooks/EntityTypes/useResourceTypes';
import { useResourceShareByID } from 'hooks/share/useResourceShareByID';
import React from 'react';
import Lottie from 'react-lottie';
import { useNavigate, useParams } from 'react-router-dom';
import sparkLoadingAnimation from 'animations/sparkLoading.json';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: sparkLoadingAnimation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

function ResourceShare() {
  const { id: resourceShareID } = useParams();
  const navigate = useNavigate();
  const { keyByIDMap } = useResourceTypes();
  const { resourceShare } = useResourceShareByID(resourceShareID);
  const { resourceID, resourceTypeID } = resourceShare?.attributes || {};

  const url = React.useMemo(() => {
    if (!keyByIDMap || !resourceTypeID) {
      return;
    }
    const resource = keyByIDMap[resourceTypeID];
    if (!resource) {
      return;
    }

    return `/${resource}/${resourceID}`;
  }, [keyByIDMap, resourceID, resourceTypeID]);

  React.useEffect(() => {
    if (!resourceShareID) {
      navigate('/dashboard');
    }
  }, [navigate, resourceShareID]);

  React.useEffect(() => {
    if (!url) {
      return;
    }
    navigate(url);
  }, [navigate, url]);

  return (
    <Grid height='100vh' container justifyContent='center' alignItems='center'>
      <Box display='flex' alignItems='center' flexDirection='column' gap={1}>
        <Lottie options={defaultOptions} height={100} width={100} />
        <Typography
          color={(theme) => theme.palette.grey[800]}
          variant='h6'
          fontFamily='Mont-semibold'
        >
          You are being redirected...
        </Typography>
        <Box sx={{ width: '100%' }}>
          <LinearProgress />
        </Box>
      </Box>
    </Grid>
  );
}

export default ResourceShare;
